import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowRightSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(-423 -2528)">
        <g transform="translate(425 2530)">
          <path d="M9.707 5.293l-5-5a1 1 0 1 0-1.414 1.414L7.586 6l-4.293 4.293a1 1 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414z" />
        </g>
      </g>
    </svg>
  );
};

ArrowRightSmall.displayName = 'ArrowRightSmall';
